import { createRouter, createWebHistory } from 'vue-router'
import RecepiesListVue from '@/views/RecepiesList.vue'
import RecepieDetails from '@/views/RecepieDetails.vue'
import RecepiesCreate from '@/views/RecepiesCreate.vue'
import LoginView from '@/views/LoginView.vue'
import { auth } from '@/firebase'

const legacyOwnerUid = 'EjrNn2sqQJgdoPsppRbu0719uaf1'
const mappedLegacyUid = 'pZGq9JUlCdNC2NqfZuIl'

const normalizeUserId = (uid) => {
  if (uid === legacyOwnerUid) {
    return mappedLegacyUid
  }
  return uid
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: RecepiesListVue
  },
  {
    path: '/:uid',
    name: 'homeByUser',
    component: RecepiesListVue
  },
  {
    path: '/bookselect',
    name: 'bookselect',
    component: () => import('@/views/BookSelect.vue')
  },
  {
    path: '/recepie/new',
    name: 'new',
    component: RecepiesCreate,
    meta: { requiresAuth: true }
  },
  {
    path: '/recepie/:uid/:id?',
    name: 'recepieView',
    component: RecepieDetails,
  },
  {
    path: '/recepie/:id?',
    redirect: (to) => {
      const id = to.params.id
      const uid = String(to.query.userId || '').trim()
      if (!uid) {
        return { name: 'bookselect' }
      }
      return { name: 'recepieView', params: { uid: normalizeUserId(uid), id } }
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  if (to.name === 'home' && to.query.userId) {
    return { name: 'homeByUser', params: { uid: normalizeUserId(String(to.query.userId)) } }
  }

  if (to.meta.requiresAuth && !auth.currentUser) {
    return { name: 'login' }
  }

  if (to.name === 'home' && auth.currentUser?.uid) {
    return { name: 'homeByUser', params: { uid: normalizeUserId(auth.currentUser.uid) } }
  }

  return true
})

export default router
